/** Shared MUI dimension for phone touch targets; wider screens keep their existing minimum. */
export const PHONE_TOUCH_SIZE = { xs: 44, sm: 'auto' } as const;
